<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/499SOv/cover.jpeg?1728169434133" alt="This image is the cover for the book Tepatasi: Le Au’alumā"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tepatasi: Le Au’alumā
      </h1>
      <p class="bookDescription body article font2">
        <p>Christianity took root in the Pacific, nowhere more so than in Samoa. As World War I raged in Europe, the Great Influenza pandemic landed in Samoa in the winter of 1918. Facing tragic losses in their adopted village, a group of outsiders stayed behind to help. Living on the fringes of society, these women were unexpectedly thrust into the epicenter of the world’s most virulent pandemic. They found purpose as healers among strangers when it was needed most.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elle A. Laga’aia
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:135.75pt;margin-bottom:10.2pt;margin-left:187.05pt;font-size:19px;font-family:"Californian FB",serif;color:black;margin:0mm;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:windowtext;'>Elle Laga&rsquo;aia was born to US Navy Samoan parents. She grew up between California and American Samoa. Elle lives in Southern California and is the mother of three daughters and a Siamese cat. In her waking hours, she supports and advocates for animal charities.</span></p><p style='margin-top:0mm;margin-right:135.75pt;margin-bottom:10.2pt;margin-left:187.05pt;font-size:19px;font-family:"Californian FB",serif;color:black;margin:0mm;text-align:justify;'><br></p><p style='margin-top:0mm;margin-right:135.75pt;margin-bottom:10.2pt;margin-left:187.05pt;font-size:19px;font-family:"Californian FB",serif;color:black;margin:0mm;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:windowtext;'>Elle enjoys traveling to circumnavigate the world, one country at a time.</span></p><p><span style='font-size:15px;font-family:"Times New Roman",serif;'><br></span></p><p style='margin-top:0mm;margin-right:135.75pt;margin-bottom:10.2pt;margin-left:187.05pt;font-size:19px;font-family:"Californian FB",serif;color:black;margin:0mm;text-align:justify;'><br></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b40d1f4e